export const BANK_CARD_TYPES = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
};
